<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-11-19 11:44:49
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-20 18:47:15
 * @Description: 
-->
<template>
  <div>
    <div class="banner_img">
      <!-- <img :src="require('../../../assets/images/0_01.png')" alt /> -->
      <img :src="townMsg.coverImageUrl" alt />
    </div>
    <div class="adress">
      <div class="first_title">小镇地址</div>
      <div class="text_infor">{{ townMsg.townAddress }}</div>
    </div>
    <div class="adress">
      <div class="first_title">入驻咨询电话</div>
      <div class="text_infor">
        <div
          class="one_tel"
          v-for="(item, index) of townMsg.consultTels"
          :key="index"
        >
          {{ item.consultTels }}
          <span class="line">|</span>
        </div>
      </div>
    </div>
    <div class="adress">
      <div class="first_title">相关链接</div>
      <div
        class="text_infor"
        v-for="(item, index) of townMsg.websites"
        :key="index"
      >
        <span>{{ item.name }}：</span>
        <span class="url_style" @click="locationHref(item.websites)">{{
          item.websites
        }}</span>
      </div>
      <div
        style="
          width: 300px;
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <el-image
          style="height: 300px; width: 300px"
          :src="require('@/assets/images/gzh.jpg')"
        ></el-image>
        <div>湘江基金小镇公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  props: ["townMsg"],
  methods: {
    locationHref(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.banner_img img {
  width: 100%;
}
.url_style {
  cursor: pointer;
  font-size: 14px;
  color: #3165ff;
  line-height: 19px;
}
.text_infor span {
  display: inline-block;
  margin: 5px 0;
}
.first_title {
  border-left: 8px solid #3165ff;
  font-size: 24px;
  color: #0f1824;
  font-weight: bold;
  padding-left: 10px;
  margin: 40px 0 15px;
}
.text_infor {
  font-size: 14px;
  color: #6c7885;
}
.text_infor .one_tel {
  display: inline;
}
.line {
  display: inline-block;
  padding: 0px 10px;
}
.one_tel:last-child .line {
  display: none;
}
</style>
